// @ts-nocheck
import React from 'react';

const Section3 = ({
  // @ts-ignore
  // @ts-ignore
  photo, text }) => {
  return (
    <>
      <section className="pb-5">
        <div className="relative flex items-center justify-center gap-10 max-md:flex-col">
          <img
            // @ts-ignore
            className="object-cover md:max-w-[400px] rounded-xl" src={photo} alt="" />
          <div
            // @ts-ignore
            className="pb-3">
            {text}
          </div>
        </div>
      </section>
    </>
  );
};

export default Section3;
